<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Properties & Infrastructures
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn @click="addSettings" outline large class="white--text">
              <v-icon left dark> add </v-icon>
              NEW
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="settingsListHeader"
          :items="settingsListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{ getFirmName(props.item.firm) }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editSetting(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteSetting(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addSettingsDialog" max-width="1000px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Settings</span>
          <v-spacer />
          <v-btn icon dark @click.native="addSettingsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-if="!currentSettings['.key']"
                  v-model="currentSettings.firm"
                ></v-select>
                <v-text-field
                  dense
                  v-else
                  :value="getFirmName(currentSettings.firm)"
                  :disabled="true"
                  label="Select Firm"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <template
                  v-for="(floor, index) in currentSettings.floorDetails"
                >
                  <v-layout row wrap :key="'floor' + index">
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        :key="index + 'fee'"
                        style="margin-top: 10px"
                        v-model="floor.name"
                        :label="'Name of floor Number : ' + (index + 1)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout
                        style="padding: 0 45px"
                        row
                        wrap
                        v-for="(room, index1) in floor.tables"
                        :key="'room' + index + '_' + index1"
                      >
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            v-model="room.name"
                            :label="index1+1 + '. Table - Name/Number'"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            type="Number"
                            v-model="room.capacity"
                            label="Table Capacity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-btn
                            icon
                            color="primary"
                            v-if="index1 == floor.tables.length - 1"
                            @click="addTables(index, index1)"
                          >
                            <v-icon>add_circle</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="removeTables(index, index1)"
                            v-else
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-btn
                        icon
                        color="primary"
                        v-if="index == currentSettings.floorDetails.length - 1"
                        @click="addFloor(index)"
                      >
                        <v-icon>add_circle</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        @click="removeFloor(index)"
                        v-else-if="index != 0"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="saveSettings"
            flat
            v-if="!currentSettings['.key']"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            @click="updateSettings"
            flat
            v-if="!!currentSettings['.key']"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import firebase from "firebase";
export default {
  data() {
    return {
      addSettingsDialog: false,
      currentSettings: {
        firm: null,
        brand: null,
        floorDetails: [
          {
            name: "",
            tables: [
              {
                name: "",
                capacity: 10,
              },
            ],
          },
        ],
      },
      settingsListHeader: [
        // { text: "Print- ID", value: "Term - ID" },
        { text: "Firm", value: "Name" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "firmInfrastructure",
      this.$root.$firebaseRefs.firmInfrastructure
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "stockReportTypes"]),
    firmsByBrand() {
      let alreadyExistsSettingsFirm = this.settingsListByBrand;
      return this.firms
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            !_.find(alreadyExistsSettingsFirm, function (o) {
              return o["firm"] == item[".key"];
            })
          );
        })
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    settingsListByBrand() {
      return this.firmInfrastructure.filter(
        (item) => item["brand"] === this.selectedBrand
      );
    },
  },
  methods: {
    saveSettings() {
      this.$root.$firebaseRefs.firmInfrastructure.push(this.currentSettings);
      this.addSettingsDialog = false;
    },

    addSettings() {
      this.currentSettings = {
        firm: null,
        brand: this.selectedBrand,
        floorDetails: [
          {
            name: "",
            tables: [
              {
                name: "",
                capacity: 10,
              },
            ],
          },
        ],
      };
      this.addSettingsDialog = true;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    editSetting(term) {
      this.currentSettings = JSON.parse(JSON.stringify(term));
      this.addSettingsDialog = true;
    },
    addTables(index, index1) {
      this.currentSettings.floorDetails[index].tables.push({
        name: "",
        capacity: 10,
      });
    },
    removeTables(index, index1) {
      this.currentSettings.floorDetails[index].tables.splice(index1, 1);
    },
    addFloor(index) {
      this.currentSettings.floorDetails.push({
        name: "",
        tables: [
             {
                name: "",
                capacity: 10,
              },
        ],
      });
    },
    removeFloor(index) {
      this.currentSettings.floorDetails.splice(index, 1);
    },
    deleteSetting(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
        this.$root.$firebaseRefs.firmInfrastructure
          .child(term[".key"])
          .remove();
      }
    },
    updateSettings() {
      let settingsToUpdate = JSON.parse(JSON.stringify(this.currentSettings));
      delete settingsToUpdate[".key"];
      this.$root.$firebaseRefs.firmInfrastructure
        .child(this.currentSettings[".key"])
        .update(settingsToUpdate, () => {
          this.currentSettings = {
            firm: null,
            brand: this.selectedBrand,
            floorDetails: [
              {
                name: "",
                tables: [
                  {
                    name: "",
                    capacity: 10,
                  },
                ],
              },
            ],
          };
          this.addSettingsDialog = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/Infrastructure/Infrastructure.vue